











































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenter } from "@/request/idr";
@Component({})
export default class MainHeaderView extends Vue {
  @Prop()
  private cState: any;
  private ifShowMenu: boolean = false;
  private centers: any[] = [];
  @Prop()
  private ifCdr: any;
  @Prop()
  private projectName: any;
  private get user() {
    return this.$store.state.user;
  }
  private get ifLowHeight() {
    if (window.innerHeight <= 670) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 获得中心列表
   */
  private fetchCenters() {
    GetCenter(this).then((data: any) => {
      // console.log(data);
      this.centers = data;
    });
  }
  /**
   * @description 跳转临床或者名中医
   */
  private jumpCenter(center) {
    switch (center.center) {
      case "临床科室数据中心":
        this.$router.push({
          path: "/main/cdr/patient-list",
          query: {
            project_id: center.project_id,
          },
        });
        break;
      case "名中医传承数据中心":
        this.$router.push({
          path: "/main/edr/patient-list",
          query: {
            project_id: center.project_id,
          },
        });
        break;
    }
  }
  /**
   * @description 跳转
   */
  private jump(url) {
    this.$router.push(url);
  }
  /**
   * @description 跳转智能看舌
   */
  private jumpTongueList() {
    localStorage.setItem(
      "tongueListFilters",
      JSON.stringify({
        hospital_ids: [],
        范围: [],
        search: "",
        性别: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        orderField: "创建时间",
        orderValue: 0,
        pageCount: 12,
        primaryFilters: {},
        totalCount: 0,
        ifPrimarySearched: false,
      })
    );
    this.$router.push("/main/tongue/tongue-list");
  }
  /**
   * @description 跳转教学管理
   */
  private jumpJxgl() {
    localStorage.setItem(
      "xtkListFilters",
      JSON.stringify({
        cate_id: "",
        题目难度: "",
        search: "",
        current_page: 1,
        page_count: 10,
        order_value: 0,
      })
    );
    this.$router.push("/main/jxgl/xtk-list");
  }
  /**
   * @description 跳转个人中心
   */
  private goAccountManage() {
    localStorage.setItem(
      "beforeAccountSource",
      JSON.stringify({
        path: this.$route.path,
        query: this.$route.query,
      })
    );
    this.$router.push({
      path: "/main/account/account-setting",
    });
  }
  /**
   * @description 登出
   */
  private logout() {
    this.$store.commit("updateToken", "");
    this.$router.push("/");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchCenters();
  }
}
